const CaretRight = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="6.34" height="9.763" viewBox="0 0 6.34 9.763">
    <path id="Path_1401" data-name="Path 1401" d="M468.847,3509.168l3.5,3.5,3.43-3.5" transform="translate(-3507.754 477.195) rotate(-90)" fill="none" stroke="#bac3c9" stroke-linecap="round" stroke-width="2" />
  </svg>

}
export default CaretRight;